import { render, staticRenderFns } from "./UserAdm.vue?vue&type=template&id=33fa60d2&scoped=true&"
import script from "./UserAdm.vue?vue&type=script&lang=js&"
export * from "./UserAdm.vue?vue&type=script&lang=js&"
import style0 from "./UserAdm.vue?vue&type=style&index=0&id=33fa60d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa60d2",
  null
  
)

export default component.exports